import React from 'react'
import { Layout } from 'ui/layout/Layout'
import { AppBarCommon } from 'ui/partials/AppBar'

const Empty: React.FC = () => {
  return <Layout header={<AppBarCommon />} />
}

export default Empty
